export type AnalyticsEvent = {
  userId: string;
  eventType: string;
  eventSubType: string;
  userRole: string;
  userCountries: string[];
  eventLocation: string;
  context: { [key: string]: unknown };
  sessionId: string;
  createdAt?: string;
  source?: string;
};

export type AnalyticsState = {
  loading: boolean;
  error: string;
  events: AnalyticsEvent[];
};

export const initialState: AnalyticsState = {
  loading: false,
  error: null,
  events: [],
};
